module.exports = __webpack_public_path__ + "img/pdf.d8e86dff.svg";